import { useEffect } from 'react';

/**
 * Names the browser tab for the current page and puts the previous title back
 * on unmount, so leaving a page does not leave its name behind on the shell
 * that follows.
 *
 * `null` means "nothing to say yet" and leaves the title alone: a detail page
 * calls this with the entity it has loaded, and before the load lands the
 * URL-derived title from the router root stands.
 */
export function useDocumentTitle(title: string | null): void {
  useEffect(() => {
    if (title === null) return undefined;
    const previous = document.title;
    document.title = title;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
